import { safeUrl } from '@/utils/safeUrl'

const OS_LABELS: Record<string, string> = {
  windows: 'Windows',
  macos: 'macOS',
  linux: 'Linux',
  android: 'Android',
  ios: 'iOS',
}

export function osLabel(os: string): string {
  return OS_LABELS[os] ?? os
}

export function formatOsList(types?: string[]): string {
  return (types ?? []).map(osLabel).join(', ')
}

export function resolveAppIconUrl(iconUrl: string | null | undefined): string | null {
  if (!iconUrl) return null
  const trimmed = iconUrl.trim()
  if (!trimmed || trimmed === '#') return null
  if (trimmed.startsWith('data:image/')) return trimmed
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed
  if (trimmed.startsWith('/')) return trimmed
  const safe = safeUrl(trimmed)
  return safe !== '#' ? safe : null
}
